import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

/**
 * Open-source MUI X Data Grid (MIT). No Pro license required.
 */
export default function ErpDataGrid({ sx, ...props }) {
  return (
    <DataGrid
      sx={{ border: 'none', ...sx }}
      {...props}
    />
  );
}
